import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faPlus, faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './hollow.css';
import { Tooltip } from 'react-tooltip';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CastingBedV from '../../Shared/CastingBedV';
import CastingDraw from '../../Shared/CastingDraw';

const Hollowform = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { slabid } = useParams();

  const [formData, setFormData] = useState(new Array(15).fill('')); // 15 fields initialized to empty string
  const [tableVisible, setTableVisible] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState('');
  const [rowIndex, setRowIndex] = useState(null);
  const [elements,setElements] = useState([]);

  useEffect(() => {
    if (location.state?.rowData) {
      const rowData = location.state.rowData;
      setElements(location.state.elements);
      setFormData(rowData);
      setExcelData(location.state.excelData);
      setFileName(location.state.fileName);
      setRowIndex(location.state.rowIndex);
    }
  }, [location]);

  useEffect(() => {
    if (fileName) {
      const fetchExcelData = async () => {
        try {
          const response = await fetch(fileName); // Assuming `fileName` is a path to the file
          const arrayBuffer = await response.arrayBuffer();
          const workbook = XLSX.read(arrayBuffer, { type: 'array' });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          setExcelData(data);
        } catch (error) {
          console.error("Error loading Excel file:", error);
        }
      };
      fetchExcelData();
    }
  }, [fileName]);

  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    setFormData((prevData) => {
      const newData = [...prevData];
      newData[index] = value;
      return newData;
    });
  };

  const addField = () => {
    setFormData(new Array(15).fill('')); // Reset formData to empty strings
    setRowIndex(excelData.length - 1); // Set rowIndex to the end of the array for a new entry
  };

  const saveData = () => {
    const headers = excelData[0]; // Assuming the first row contains headers
    const newData = [...excelData];

    // Find the first empty row after the headers
    let insertIndex = 1; // Start after headers
    while (insertIndex < newData.length && newData[insertIndex].some(cell => cell !== undefined && cell !== null && cell !== '')) {
      insertIndex++;
    }

    // Insert formData at the first empty row index
    newData[insertIndex] = formData;

    const worksheet = XLSX.utils.aoa_to_sheet(newData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const modifiedFileName = `${fileName}`;
    XLSX.writeFile(workbook, modifiedFileName);
    toast.success('Data saved successfully');
  };

  const GoBack = () => {
    navigate(-1); // Navigates back to the previous page
  };

  return (
    <>
      <div className='card hollowtable'>
        <ToastContainer />
        <div className='TruckForm'>
          <div className='card-header'>
            
            <div>
            <button type="button" className="toggle-table-icon" onClick={GoBack}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <h2 className='title-hollow px-2'>Hollow Detail</h2>
            </div>
            <div className='ctrl-btns-hollow'>
              <button className='btn' id='add' onClick={addField}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
              <Tooltip anchorSelect='#add' content='Add' place='bottom' />
              <button className='btn' id='save' onClick={saveData}>
                <FontAwesomeIcon icon={faSave} />
              </button>
              <Tooltip anchorSelect='#save' content='Save' place='bottom' />
            </div>
          </div>
        </div>
        {tableVisible && (
          <div className='card-body'>
            <div className='ApprovalForm'>
              <form>
                <div className='row row1'>
                  <div className='col-3 leftCol'>
                    <span>
                      <label className='section-title-hollow'>Structural Specification</label>
                    </span>
                    <br />
                    <br />
                    {['Slab ID', 'Slab Code', 'Description', 'Design Width', 'Design Length', 'Design Height'].map((label, index) => (
                      <div className='label-input-box-hollow' key={index}>
                        <input
                          type='text'
                          name={label.replace(/\s+/g, '')}
                          className='Elementidinput-report'
                          value={formData[index] || ''}
                          onChange={(e) => handleInputChange(e, index)}
                          placeholder=' '
                        />
                        <label>{label}</label>
                      </div>
                    ))}
                  </div>
                  <div className='col-3 midCol'>
                    <span>
                      <label className='section-title-hollow'>Reinforcement Details</label>
                    </span>
                    <br />
                    <br />
                    {['Strand Type', 'Cross to Sectional Area', 'Top Strand', 'Bottom Strand', 'Cover to Strand'].map((label, index) => (
                      <div className='label-input-box-hollow' key={index + 6}>
                        <input
                          type='text'
                          name={label.replace(/\s+/g, '')}
                          className='Elementidinput-report'
                          value={formData[index + 6] || ''}
                          onChange={(e) => handleInputChange(e, index + 6)}
                          placeholder=' '
                        />
                        <label>{label}</label>
                      </div>
                    ))}
                  </div>
                  <div className='col-3 rightColFormh'>
                    <span>
                      <label className='section-title-hollow'>Material and Fire Resistance</label>
                    </span>
                    <br />
                    <br />
                    {['Concrete Grade', 'Fire Rating', 'Self Weight', 'Self Weight (incl Screed)'].map((label, index) => (
                      <div className='label-input-box-hollow' key={index + 11}>
                        <input
                          type='text'
                          name={label.replace(/\s+/g, '')}
                          className='Elementidinput-report'
                          value={formData[index + 11] || ''}
                          onChange={(e) => handleInputChange(e, index + 11)}
                          placeholder=' '
                        />
                        <label>{label}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        {formData[3] && formData[4] && <CastingDraw elements={elements} width={formData[3]} length={formData[4]} />}
      </div>
    </>
  );
};

export default Hollowform;
